import { authenticatedApi } from '../../../shared/api/apiClientUtils';

export interface RecycleBinItemDto {
  id: string;
  name: string;
  type: 'file' | 'folder';
  originalSiteName: string | null;
  originalFolderPath: string | null;
  originalParentId: string | null;
  deletedBy: string | null;
  deletedAt: string | null;
  scheduledPurgeAt: string | null;
  fileSizeBytes: number | null;
  childFileCount: number | null;
}

export const recycleBinKeys = {
  all: ['recycle-bin'] as const,
  list: (siteId?: number) => [...recycleBinKeys.all, siteId] as const,
};

export async function getRecycleBin(
  siteId?: number
): Promise<RecycleBinItemDto[]> {
  const params = siteId ? `?siteId=${siteId}` : '';
  const { data } = await authenticatedApi.get<RecycleBinItemDto[]>(
    `/api/v1/files/recycle-bin${params}`
  );
  return data;
}

export async function restoreFile(
  fileId: string,
  body?: { newName?: string; replaceFileId?: string }
): Promise<void> {
  await authenticatedApi.post(`/api/v1/files/${fileId}/restore`, body ?? {});
}

export async function restoreFolder(folderId: string): Promise<void> {
  await authenticatedApi.post(`/api/v1/folders/${folderId}/restore`, null);
}

export async function permanentDeleteFile(fileId: string): Promise<void> {
  await authenticatedApi.delete(`/api/v1/files/${fileId}/permanent`);
}

export async function permanentDeleteFolder(folderId: string): Promise<void> {
  await authenticatedApi.delete(`/api/v1/folders/${folderId}/permanent`);
}
